import { combineReducers } from 'redux'

import activityDashboard from 'src/store/modules/admin/activityDashboard'
import activityLog from 'src/store/modules/admin/activityLog'
import broadcast from 'src/store/modules/admin/broadcast'
import gamification from 'src/store/modules/admin/gamification'
import caseManagers from 'src/store/modules/company/caseManagers'
import diseases from 'src/store/modules/company/diseases'
import employees from 'src/store/modules/company/employees'
import references from 'src/store/modules/company/refs'
import structure from 'src/store/modules/company/structure'

export default combineReducers({
  activityDashboard,
  activityLog,
  broadcast,
  caseManagers,
  diseases,
  employees,
  gamification,
  references,
  structure
})

export * from 'src/store/modules/company/refs'
export * from 'src/store/modules/company/diseases'
export * from 'src/store/modules/company/structure'
export * from 'src/store/modules/company/caseManagers'
export * from 'src/store/modules/admin/broadcast'
export * from 'src/store/modules/company/employees'
